
export function money(n) {
  if (n === null || n === undefined || isNaN(n)) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(Number(n));
}

const STATE_PART = /^([A-Za-z]{2})(\s+\d{5}(-\d{4})?)?$/;
const CITY_STATE_ZIP = /^([A-Za-z][A-Za-z .'-]*?)\s+([A-Za-z]{2})\s+\d{5}(-\d{4})?$/;

// "123 Main St, Indianapolis, IN 46204, USA" -> "Indianapolis, IN"
export function cityState(addr, max = 28) {
  const text = String(addr || "").trim();
  const parts = text.split(",").map((p) => p.trim()).filter(Boolean)
    .filter((p) => !/^(usa|us|united states( of america)?)$/i.test(p));
  for (let i = parts.length - 1; i >= 0; i--) {
    const m = parts[i].match(STATE_PART);
    if (m && i > 0 && !/^\d/.test(parts[i - 1])) return `${parts[i - 1]}, ${m[1].toUpperCase()}`;
    const z = parts[i].match(CITY_STATE_ZIP);
    if (z) return `${z[1]}, ${z[2].toUpperCase()}`;
  }
  return text.length > max ? `${text.slice(0, max).trimEnd()}…` : text;
}

export function dateShort(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}

export const INVOICE_STYLES = {
  Draft: "bg-slate-100 text-slate-700 border border-slate-200",
  Sent: "bg-blue-50 text-blue-700 border border-blue-200",
  Paid: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Overdue: "bg-rose-50 text-rose-700 border border-rose-200",
};

export const STATUS_STYLES = {
  "New": "bg-slate-100 text-slate-700 border border-slate-200",
  "In Progress": "bg-blue-50 text-blue-700 border border-blue-200",
  "Delivered": "bg-emerald-50 text-emerald-700 border border-emerald-200",
  "Invoiced": "bg-indigo-50 text-indigo-700 border border-indigo-200",
};
